module.exports = __webpack_public_path__ + "static/media/excerpt_overlay.df8b9446.png";